
export enum Value {
	BorderRadius = '2rem',
	BorderRadius_Field = '0.8rem',
	BorderRadius_Button = '2rem',
	BorderRadius_Tooltip = '0.8rem'
}
